import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import { useFileDispatch } from '../context/FileContext';
import { api } from '../api/apis';
import JSZip from 'jszip';
import './ExpandableSection.css';

const ProcessFile = () => {
    const [fileSelectionError, setFileSelectionError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [processOption, setProcessOption] = useState('');
    const [audioFile, textFile,,,,, setStatisticsHandler, resetStatisticsHandler] = useFileDispatch();
    const [downloadLink, setDownloadLink] = useState(null);
    const [clips, setClips] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);

    const isButtonEnabled = () => {
        if (processOption === 'selectFromExamples') {
            return typeof(audioFile) === 'string' && audioFile !== '';
        } else if (processOption === 'selectFromAudio') {
            return audioFile && typeof(audioFile) !== 'string';
        }
        return false;
    };

    const processFileHandler = () => {
        if (!processOption) {
            alert("Please select a processing option.");
            return;
        }
        if (!isButtonEnabled()) {
            setFileSelectionError(true);
            return;
        }

        setFileSelectionError(false);
        setLoading(true);
        resetStatisticsHandler();

        setDownloadLink(null);
        setClips([]);

        const formData = new FormData();
        formData.append("audio", audioFile);
        const textContent = typeof(textFile) === 'string' ? textFile : textFile.file;
        formData.append("text", textContent);

        let endpoint = processOption === 'selectFromExamples' ? "/api/processExample" : "/api/process";
        api.post(endpoint, formData)
            .then(response => {
                handleResponse(response);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                alert(error);
                setLoading(false);
            });
    };

    const handleResponse = (response) => {
        const url = `${process.env.REACT_APP_SERVER_URL}:${process.env.REACT_APP_SERVER_PORT}/` + response.data.zip_file;
        const stats = {
            process_time: response.data.time_count,
            word_count: response.data.word_count,
            coverage: response.data.percentage
        };

        console.log(stats);
        setDownloadLink(url);
        setStatisticsHandler(stats);

        extractAndDisplayClips(url);
    };

    const extractAndDisplayClips = async (zipFileUrl) => {
        try {
            const response = await fetch(zipFileUrl);
            const arrayBuffer = await response.arrayBuffer();
            const zip = await JSZip.loadAsync(arrayBuffer);
            const files = zip.files;
            const newClips = [];

            for (let filename in files) {
                if (newClips.length >= 10) break;
                if (filename.endsWith('.mp3')) {
                    const audioBlob = await files[filename].async('blob');
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const transcriptFile = filename.replace('.mp3', '.txt');
                    const transcriptBlob = await files[transcriptFile].async('string');
                    newClips.push({ audioUrl, transcript: transcriptBlob });
                }
            }

            setClips(newClips);
        } catch (error) {
            console.error('Error extracting clips:', error);
        }
    };

    const handleDownload = () => {
        if (downloadLink) {
            const link = document.createElement('a');
            link.href = downloadLink;
            link.target = "_blank";
            const fileName = typeof(audioFile) === 'string' ? audioFile.split('.')[0] : audioFile.name.split('.')[0];
            link.setAttribute('download', `${fileName}.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadLink);
        } else {
            alert('No file to download');
        }
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        if(audioFile) {
            setFileSelectionError(false);
        }
    }, [audioFile]);

    return (
        <div>
            <div className="flex justify-center space-x-4 items-center">
                <div style={{border: '2px solid #4a90e2', borderRadius: '8px', padding: '10px', backgroundColor: '#f0f0f0'}}>
                    <label style={{fontWeight: 'bold', color: '#333'}}>
                        <input 
                            type="radio" 
                            name="processOption"
                            value="selectFromExamples" 
                            checked={processOption === 'selectFromExamples'} 
                            onChange={(e) => setProcessOption(e.target.value)}
                            style={{marginRight: '5px'}}
                        /> Select from Examples
                    </label>
                    <label style={{fontWeight: 'bold', color: '#333', marginLeft: '20px'}}>
                        <input 
                            type="radio" 
                            name="processOption"
                            value="selectFromAudio" 
                            checked={processOption === 'selectFromAudio'} 
                            onChange={(e) => setProcessOption(e.target.value)}
                            style={{marginRight: '5px'}}
                        /> Select from Upload
                    </label>
                </div>
                <button 
                    className={`bg-blue-500 px-4 py-1 text-white rounded-md ${isButtonEnabled() ? 'active:bg-blue-600' : 'opacity-50 cursor-not-allowed'}`} 
                    onClick={processFileHandler}
                    disabled={!isButtonEnabled()}
                >
                    Process
                </button>
            </div>
            {loading && <Loading />}
            {fileSelectionError &&
                <div>
                    <p className="text-red-700">Please select the appropriate file type to process!</p>
                </div>
            }
            {downloadLink && (
                <div className="expandable-section mt-4">
                    <div className="expandable-header" onClick={toggleExpand}>
                        <div className="header-content">
                            <button onClick={handleDownload} className="bg-green-500 px-4 py-1 text-white rounded-md ml-4">
                                Download ZIP File
                            </button>
                            <h2 className="text-lg font-semibold mb-1">View clips from this download</h2>
                        </div>
                        <span className={`arrow ${isExpanded ? 'open' : ''}`}>&#9654;</span>
                    </div>
                    <div className={`expandable-content ${isExpanded ? 'show' : ''}`}>
                        {clips.map((clip, index) => (
                            <div key={index} className="clip-item">
                                <audio controls src={clip.audioUrl} />
                                <p className="clip-transcript">{clip.transcript}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProcessFile;
